import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy, AfterViewChecked,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    HostListener, ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BufferGraphService} from 'app/buffer-graph/services/buffer-graph.service';
import {CommonDataService} from 'app/services/common-data.service';

import {ChartHelper} from "app/buffer-graph/models/chart-helper";
import * as Popper from 'popper.js/dist/umd/popper';
import * as moment from "moment";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import {ChartData} from "../../models/chart-data";
import {ChartGetDataModel} from "../../models/amchart/chart-exchange";
// import {BufferGraphChartComponent} from "../buffer-graph-chart.component/buffer-graph-chart.component";
import {CodeNameListComponent} from "../code-name-list.component/code-name-list.component";
import {CodeName} from "../../../stocks/models/code-name";
import {ChartListProps} from "../../models/amchart/chart-list-props";
import {ISubscription} from "rxjs/Subscription";

type InitialData = { accessDenied: boolean, rights: any };

@Component({
    selector: 'chart-period-selector',
    templateUrl: './chart-period-selector.component.html',
    styleUrls: ['./chart-period-selector.component.css']
})
export class ChartPeriodSelectorComponent implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                public readonly commonData: CommonDataService,
                private readonly graphService: BufferGraphService,
                public readonly dataExchange: BufferGraphDataExchangeService,
    ){
        this.helper = new ChartHelper();
        // this.hide = new EventEmitter<{ startDate: string, endDate: string }>();
        this.addChartOut = new EventEmitter<number>();
        this.updPopperOut = new EventEmitter<boolean>();
        this.datesOut = new EventEmitter<{ startDate: string, endDate: string }>();
        this.initialise();
    }

    private initialise = (): void =>{
        this._startDate = '';
        this._endDate = '';
        this.type = '0';
        this.daysQuantity = '92';
        this.flexWrap = false;
        this.warehouseWidth = 'auto';
        this.itemIdWidth = 'auto';
        this.itemIdWidth = 'auto';
        this.footerWidth = 'auto';
        this.clearValidation();
    };

    @Input()
    public set chartData(chartData: ChartData){
        if (chartData){
            this._chartData = chartData;
            if (!this.addChart){
                this.setData();
            }
        }
    };

    public get chartData(): ChartData{
        return this._chartData;
    }

    @Input() public isAdmin: boolean;
    @Input() public chartType: string;
    @Input() public GUID: string;
    @Input() public sharedGUID: string;
    // @Input() public isMainChart: boolean;
    @Input() private wrpRef: ElementRef;
    @Input() private addChart?: boolean;
    @Input() private hiddenSelect?: boolean;
    @Input() private disableItemSelect?: boolean;
    @Input() private hideDates?: boolean;
    @Input() private hideItems?: boolean;
    @Input() private autoUpdateSize?: boolean;

    @Input()
    private set wrpSize(val: number){
        // console.log(val, 'wrpSize input')
        this.updateSizes = true;
    }

    @Output()
    //private readonly hide: EventEmitter<{ startDate: string, endDate: string }>;

    @Output()
    private readonly addChartOut: EventEmitter<number>;

    @Output()
    private readonly updPopperOut: EventEmitter<boolean>;

    @Output()
    private readonly datesOut: EventEmitter<{ startDate: string, endDate: string }>;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('skuListBtn')
    public skuListBtn: ElementRef;

    @ViewChild('wrhListBtn')
    public wrhListBtn: ElementRef;

    @ViewChild('skuList')
    public skuList: CodeNameListComponent;

    @ViewChild('wrhList')
    public wrhList: CodeNameListComponent;

    @ViewChild('itemSelectorWrp')
    public itemSelectorWrp: ElementRef;

    @ViewChild('itemIdWrp')
    public itemIdWrp: ElementRef;

    @ViewChild('footerWrp')
    public footerWrp: ElementRef;

    @ViewChild('datesWrp')
    public datesWrp: ElementRef;

    @ViewChild('wrhListEl')
    public wrhListEl: ElementRef;

    @ViewChild('SKUListEl')
    public SKUListEl: ElementRef;

    @ViewChild('toggleShowPeriod')
    public toggleShowPeriod: ElementRef;

    @ViewChild('showPopupWrp')
    public showPopupWrp: ElementRef;

    @HostListener('window:resize', ['$event'])
    private onResize = (event): void =>{
        this.updateSizes = true
    }

    private helper: ChartHelper;
    public _startDate: string;
    public _endDate: string;
    public oldStartDate: string;
    public oldEndDate: string;
    public startDateValid: string;
    public endDateValid: string;
    public daysQuantityValid: string;
    public skuValid: string;
    public wrhCodeValid: string;
    public itemIdValid: string;
    public model: any;
    private _sku: string;
    private _wrhCode: string;
    private _itemId: number;
    public _chartData: ChartData;
    private skuUpdated: boolean;
    private wrhUpdated: boolean;
    private itemIdUpdated: boolean;
    public showSKUList: boolean;
    public showWrhList: boolean;
    public disableSKUBtn: boolean;
    public disableWrhBtn: boolean;
    public skuName: string;
    public wrhName: string;
    public flexWrap: boolean;
    public flexWrapInput: boolean;
    public warehouseWidth: string;
    public itemWidth: string;
    public itemIdWidth: string;
    public footerWidth: string;
    public itemSelectorWidth: string;
    public updateSizes: boolean;
    private checkFroRedundantWidth: boolean;
    public toggleSelect: boolean;
    public datesWidth: string;
    public datesChange: boolean;
    private subscriptionNewGraphData: ISubscription;

    private setInterval: any;

    private popperAddVar: Popper;

    private daysQuantity: string;
    private type: string;

    private listenContextMenu: () => void;
    private listenMouseDown: () => void;


    ngOnInit(){
        if (this.chartData){
            this.daysQuantity = this.chartData.visibleDaysCount.toString();
            this.startDate = this.oldStartDate = this.chartData.startDate.format('YYYY-MM-DD');
            this.endDate = this.oldEndDate = this.chartData.endDate.format('YYYY-MM-DD');
            this.maxDays('start');
        }


        if (!this.addChart){
            this.setData();
        }

        this.subscriptionNewGraphData = this.dataExchange.newChartDataCurrent.subscribe((r: ChartGetDataModel) =>{
            // console.log(r, 'subscriptionNewGraphData')
            this.helper.tryCatch(() => {
                if (r){
                    console.log(r.type, this.chartType, r.sharedGUID === this.sharedGUID, 'subscriptionNewGraphData')
                }

                if (r && r.type === this.chartType && r.sharedGUID === this.sharedGUID){
                    console.log(this.startDate, this.endDate, 'subscriptionNewGraphData')
                    this.startDate = r.startDate;
                    this.endDate = r.endDate;
                }
            })
        });

        this.hiddenSelect ? this.toggleSelect = false : this.toggleSelect = true;
        this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e));
    }

    ngOnDestroy(){
        clearInterval(this.setInterval);
        this.setInterval = null;
        // this.listenContextMenu();
        this.listenMouseDown && this.listenMouseDown();
        this.subscriptionNewGraphData.unsubscribe();
    }

    ngAfterViewInit(){
        // console.log(this.chartType, 'chartType')
        this.helper.wait(() =>{
            // this.updateSizes = true;
        });

        this.hiddenSelect && !this.hideDates ? this.popperAddVar = this.helper.popperAdd(this.toggleShowPeriod, this.datesWrp, this.wrpRef, 'bottom-start', ['bottom-start'], false) : null;


        // this.autoUpdateSize ? this.setInterval = setInterval(() => this.updateSizes = true, 1000) : null;


        // this.listenContextMenu = this.renderer.listen('body', 'contextmenu', (e: MouseEvent) => this.hideMenu(e));
        // this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideMenu(e));
    }

    ngAfterViewChecked(){
        if (this.updateSizes){
            //console.log('updateSizes')
            this.updateSizes = false;
            this.checkWidth();
            this.updateSize(this.mainWrapper.nativeElement.offsetWidth);
            this.helper.wait(() =>{
                this.updateDatesWidth();
                this.popperAddVar ? this.popperAddVar.update() : null;
                this.helper.wait(() =>{
                    // this.popperAddVar ? this.popperAddVar.update() : null;
                }, 10)
            }, 100)
        }

        if (this.checkFroRedundantWidth){
            this.checkFroRedundantWidth = false;
            this.removeRedundantWidth();
        }
    }

    public set startDate(val: string){
        if (this._startDate !== val){
            this._startDate = val;
        }
    }

    public get startDate(){
        return this._startDate
    }

    public set endDate(val: string){
        if (this._endDate !== val){
            this._endDate = val;
        }
    }

    public get endDate(){
        return this._endDate
    }

    public set sku(val: string){
        if (this._sku !== val){
            this.skuUpdated = !!val;
            this._sku = val;
        }
    }

    public get sku(){
        return this._sku
    }

    public set wrhCode(val: string){
        if (this._wrhCode !== val){
            this.wrhUpdated = !!val;
            this._wrhCode = val;
        }
    }

    public get wrhCode(){
        return this._wrhCode
    }

    public set itemId(val: number){
        if (this._itemId !== val){
            this.itemIdUpdated = !!val;
            this._itemId = val;
        }
    }

    public get itemId(){
        return this._itemId
    }

    //# return formatted date
    public localData = (data: string): string =>{
        return moment.utc(data).format(this.helper.getLocale(this.translateService.currentLang));
    }

    //# set new data if chart data updates
    private setData = (): void =>{
        this.sku = this.chartData.itemInfo.sku;
        this.wrhCode = this.chartData.itemInfo.warehouseCode;
        this.itemId = this.chartData.itemInfo.itemId;
        this.skuName = this.chartData.itemInfo.name;
        this.wrhName = this.chartData.itemInfo.warehouseName;
    }

    //# set shared data for get model, saved dates for info-tab component when it updates chart
    private setSharedData = (): void =>{
        let chartGetData: ChartGetDataModel[] = this.dataExchange.getChartGetData(),
            chartGetDataCur = new ChartGetDataModel(this.GUID, this.sharedGUID, this.type, this.itemId, this.startDate, this.endDate);
        if (chartGetData.length){
            chartGetData.forEach((item, i, arr) =>{
                if (item.GUID === this.GUID){
                    arr[i] = chartGetDataCur;
                }
            })
        } else{
            chartGetData.push(chartGetDataCur);
        }

        this.dataExchange.setChartGetData(chartGetData);

    };

    //# inner validation dates in inputs, or, update dates in inputs on init
    private maxDays = (change: string, validate: boolean = false): boolean =>{
        let endDate = moment.utc(this.endDate, "YYYY-MM-DD");
        let startDate = moment.utc(this.startDate, "YYYY-MM-DD");

        let ms = endDate.diff(startDate),
            d = moment.duration(ms),
            s = d.asDays();

        if (s <= 0){
            return false;
        }

        if (validate){
            return true;
        }

        switch (change){
            case 'start':
                if (s > 0 && s <= this.chartData.maxDaysCount){
                    return true;
                } else if (s > this.chartData.maxDaysCount){
                    this.endDate = startDate.add(this.chartData.maxDaysCount, 'days').format('YYYY-MM-DD');
                    return true;
                }
                break;
            case 'end':
                if (s > 0 && s <= this.chartData.maxDaysCount){
                    return true;
                } else if (s > this.chartData.maxDaysCount){
                    this.startDate = endDate.add(-this.chartData.maxDaysCount, 'days').format('YYYY-MM-DD');
                    return true;
                }
                break;
        }
        return false;
    };

    private log = () =>{
        console.log(this.endDate, this.startDate, 'this.endDate, this.startDate')
    };


    private clearValidation = (): void =>{
        this.startDateValid = '';
        this.endDateValid = '';
        this.daysQuantityValid = '';
        this.itemIdValid = '';
        this.skuValid = '';
        this.wrhCodeValid = '';
    }

    //# validate entered data into inputs
    private validate = (): boolean =>{
        const wrongDate = 'Chart_WrongDate';
        this.clearValidation();
        if (!this.addChart){
            switch (this.type){
                case '0':
                    this.startDateValid = this.startDate ? '' : wrongDate;
                    this.endDateValid = this.endDate ? '' : wrongDate;
                    if (!this.maxDays('', true)){
                        this.startDateValid = wrongDate;
                        this.endDateValid = wrongDate;
                    }
                    break;
                case '1':
                    this.startDateValid = this.startDate ? '' : wrongDate;
                    this.daysQuantityValid = Number(this.daysQuantity) <= this.chartData.maxDaysCount && Number(this.daysQuantity) > 0 ? '' : 'Chart_WrongDays';
                    break;
                case '2':
                    this.endDateValid = this.endDate ? '' : wrongDate;
                    this.daysQuantityValid = Number(this.daysQuantity) <= this.chartData.maxDaysCount && Number(this.daysQuantity) > 0 ? '' : 'Chart_WrongDays';
                    break;
            }

            if (this.startDateValid || this.endDateValid){
                this.translateService.get(wrongDate).subscribe(r => this.commonData.showErrors([r]))
            }

            if (this.daysQuantityValid){
                this.translateService.get(this.daysQuantityValid).subscribe(r => this.commonData.showErrors([`${r} (Min = 1, Max = ${this.chartData.maxDaysCount})`]))
            }
        }

        if (!this.sku){
            this.skuValid = 'Chart_SKUValid';
            this.translateService.get(this.skuValid).subscribe(r => this.commonData.showErrors([r]))
        }

        if (!this.wrhCode){
            this.wrhCodeValid = 'Chart_WarehouseCodeValid';
            this.translateService.get(this.wrhCodeValid).subscribe(r => this.commonData.showErrors([r]))
        }

        if (!this.itemId){
            this.itemIdValid = 'Chart_ItemIdValid';
            this.translateService.get(this.itemIdValid).subscribe(r => this.commonData.showErrors([r]))
        }

        return !this.endDateValid && !this.startDateValid && !this.daysQuantityValid && !this.skuValid && !this.wrhCodeValid && !this.itemIdValid;
    };

    //# transpile days quantity to date
    private updateDates = (): void =>{
        switch (this.type){
            case '1':
                this.endDate = moment.utc(this.startDate, "YYYY-MM-DD").add(Number(this.daysQuantity), 'days').format(this.helper.input_Date);
                break;
            case '2':
                this.startDate = moment.utc(this.endDate, "YYYY-MM-DD").add(-Number(this.daysQuantity), 'days').format(this.helper.input_Date);
                break;
        }
    };

    //# apply result of selection
    public apply = (): void =>{
        if (!this.validate()){
            return;
        }

        this.updateDates();

        if (this.addChart){
            this.addChartOut.emit(this.itemId);
        } else if (this.chartType === 'infoPanel'){
            this.datesOut.emit({startDate: this.startDate, endDate: this.endDate});
        } else{
            this.setSharedData();
            this.dataExchange.setNewChartData(new ChartGetDataModel(this.GUID, this.sharedGUID, this.chartType, this.itemId, this.startDate, this.endDate));
        }

        this.datesChange = !this.checkDatesForChange();
        this.hiddenSelect ? this.toggleSelect = false : null;

    };

    //# check for need data update, and apply result of selection
    public updatePriority = (): void =>{
        //console.log(this.itemIdUpdated, this.wrhUpdated, this.skuUpdated, 'this.itemIdUpdated && this.wrhUpdated && this.skuUpdated')

        if (this.itemIdUpdated && this.wrhUpdated && this.skuUpdated){
            this.apply();
        } else if (this.wrhUpdated && this.skuUpdated){
            this.updateGraphData();
        } else{
            this.validate();
            //this.apply('Apply');
        }
    };

    //# get updated itemId and and apply result of selection
    private updateGraphData = (): void =>{
        this.graphService.getItemId(this.wrhCode, this.sku).subscribe(data =>{
            //console.log( data, 'updateGraphData');
            if (!data){
                this.translateService.get('LoadItemIdError').subscribe(error =>{
                    this.commonData.showErrors([error]);
                });
                return;
            }

            if (data.itemId === null || !data.itemId){
                this.translateService.get('GoodNotFound').subscribe(r => this.commonData.showErrors([r]))
            } else{
                this.itemId = data.itemId;
                this.apply();
            }
        })
    };

    //# get itemID, if it not found show error message
    private getItemId = async (wrhCode: string, skuCode: string): Promise<number> =>{
        let data = await this.graphService.getItemId(wrhCode, skuCode).toPromise();
        //console.log(data, 'data');

        if (!data || !data.itemId){
            this.translateService.get('LoadItemIdError').subscribe(error =>{
                this.commonData.showErrors([error]);
            });
            return null;
        }

        return data.itemId;
    };

    //# update parameters after update filter restrictions
    public updateParameters = async (filterName: string, data: CodeName): Promise<void> =>{
        switch (filterName){
            case 'SKUs':
                this.sku = data.code;
                this.skuName = data.name;
                break;
            case 'Warehouses':
                this.wrhCode = data.code;
                this.wrhName = data.name;
                break;
        }

        this.itemId = this.wrhCode && this.sku ? await this.getItemId(this.wrhCode, this.sku) : null;
        this.updateFilter(filterName, data);
        if (this.addChart) this.updPopperOut.emit(true);
    };

    //# update filter restrictions
    public updateFilter = (filterName: string, data?: CodeName): void =>{
        let chartListProps: ChartListProps[] = this.dataExchange.getChartListProps(),
            chartListProp = chartListProps.find(item => item.GUID === this.GUID);
        switch (filterName){
            case 'SKUs':
                chartListProp.filter.skus = data ? [data.code] : [];
                break;
            case 'Warehouses':
                chartListProp.filter.warehouses = data ? [data.code] : [];
                break;
        }
        this.dataExchange.setChartListProps(chartListProps);

        //console.log(this.dataExchange.getChartListProps(), 'this.dataExchange.getChartListProps()')
    };

    //# clear parameters and update filter restrictions
    public clearParameter = (filterName: string): void =>{
        switch (filterName){
            case 'SKUs':
                this.sku = '';
                this.skuName = '';
                break;
            case 'Warehouses':
                this.wrhCode = '';
                this.wrhName = '';
                break;
        }
        this.updateFilter(filterName);
        if (this.addChart) this.updPopperOut.emit(true);
    };

    //# toggle dates visibility,
    public showDates = (): void =>{
        this.toggleSelect = !this.toggleSelect;
        this.updateDatesWidth();
        this.popperAddVar && this.popperAddVar.update();
    }

    //# hide period selector
    private hideList = (e: MouseEvent): void =>{
        if (!this.datesWrp || !this.toggleShowPeriod){
            return;
        }

        let clickOnList = this.helper.hideList(this.datesWrp, e, this.renderer) && this.helper.hideList(this.toggleShowPeriod, e, this.renderer);
        if (clickOnList){
            this.toggleSelect = false;
            this.updateDatesWidth();
        }
    };

    //# show SKUs or Warehouses selection form
    public showList = (filterName: string, e: Event): void =>{
        this.addChart ? e.stopPropagation() : null;
        if (this.disableItemSelect){
            return;
        }

        switch (filterName){
            case 'SKUs':
                !this.showSKUList ? this.showSKUList = true : null;
                break;
            case 'Warehouses':
                !this.showWrhList ? this.showWrhList = true : null;
                break;
        }
    }

    public stopProp = (e: Event): void =>{
        this.addChart ? e.stopPropagation() : null;
    }

    //# calculate width of itemSelectorWrp
    private checkWidth = (): void =>{
        if (this.hideDates){
            return;
        }
        // this.itemSelectorWidth = 'auto';
        // this.flexWrap = false;
        this.helper.wait(() =>{
            // console.log('checkWidth work')


            let datesWrpWidth: number = this.hiddenSelect
                ? this.helper.getInnerWidth(this.showPopupWrp.nativeElement)
                : this.helper.getInnerWidth(this.datesWrp.nativeElement);
            datesWrpWidth += 25;

            if (this.mainWrapper && this.mainWrapper.nativeElement){
                if (this.isAdmin && this.mainWrapper.nativeElement.offsetWidth - datesWrpWidth < 515){
                    this.itemSelectorWidth = '100%';
                    this.flexWrap = true;
                } else if (!this.isAdmin && this.mainWrapper.nativeElement.offsetWidth - datesWrpWidth < 300){
                    this.itemSelectorWidth = '100%';
                    this.flexWrap = true;
                } else{
                    this.itemSelectorWidth = `${this.mainWrapper.nativeElement.offsetWidth - datesWrpWidth}px`;
                    this.flexWrap = false;
                }
            }
        });

    }

    //# calculate width of wrhListEl and SKUListEl
    private updateSize = (wrpSize: number): void =>{
        if (this.addChart || this.hideItems){
            return;
        }

        this.helper.wait(() =>{
            // console.log(wrpSize, 'wrpSize')
            let mainWrpWidth = this.mainWrapper.nativeElement.offsetWidth;
            mainWrpWidth < 505 ? this.flexWrapInput = true : this.flexWrapInput = false;

            let itemSelectorWrp = this.itemSelectorWrp ? (this.itemSelectorWrp.nativeElement.offsetWidth - this.itemSelectorWrp.nativeElement.style.paddingLeft - this.itemSelectorWrp.nativeElement.style.paddingRight) : 0;

            if (!itemSelectorWrp){
                return;
            }

            // this.selectorWidth = 'auto';
            // this.itemIdWidth = 'auto';
            // this.footerWidth = 'auto';
            this.warehouseWidth = this.itemWidth = 'auto';
            this.helper.wait(() =>{

                let footerWidth = this.footerWrp.nativeElement.offsetWidth;

                if (itemSelectorWrp - footerWidth > 300){
                    this.warehouseWidth = this.itemWidth = `${(itemSelectorWrp - footerWidth - 10) / 2}px`;
                    // console.log(itemSelectorWrp, 'itemSelectorWrp')
                    // console.log(footerWidth, 'footerWidth')
                    // console.log(this.selectorWidth, 'selectorWidth')
                    // this.selectorWidth = ((itemSelectorWrp - footerWidth - 4) * 100 / itemSelectorWrp) / 2;
                    this.checkFroRedundantWidth = true;
                } else{
                    this.warehouseWidth = this.itemWidth = '100%';
                }
            }, 10)
        });
    }

    //# remove Redundant Width for wrhListEl and SKUListEl
    private removeRedundantWidth = (): void =>{
        this.helper.wait(() =>{
            // this.helper.wait(() => {
            let wrhInnerWidth = this.helper.getInnerWidth(this.wrhListEl.nativeElement);
            let itemInnerWidth = this.helper.getInnerWidth(this.SKUListEl.nativeElement);

            if (this.wrhListEl.nativeElement.offsetWidth > wrhInnerWidth){
                this.warehouseWidth = `${wrhInnerWidth + 1}px`;
            }
            if (this.SKUListEl.nativeElement.offsetWidth > itemInnerWidth){
                this.itemWidth = `${itemInnerWidth + 1}px`;
            }
            // })
        })
    }

    //# update Width of datesWrp
    private updateDatesWidth = (): void =>{
        let mainWrpWidth = this.mainWrapper.nativeElement.offsetWidth;
        mainWrpWidth < 505 ? this.flexWrapInput = true : this.flexWrapInput = false;
        this.toggleSelect
            ? this.datesWidth = this.mainWrapper.nativeElement.offsetWidth + 'px'
            : this.datesWidth = 'auto'
    }

    //# check if date was changed
    private checkDatesForChange = (): boolean =>{
        return moment.utc(this.startDate).format(this.helper.ru_Date) === moment.utc(this.oldStartDate).format(this.helper.ru_Date)
            && moment.utc(this.endDate).format(this.helper.ru_Date) === moment.utc(this.oldEndDate).format(this.helper.ru_Date)
    }
}




// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/chart-period-selector.component/chart-period-selector.component.ts